import CSS from './color-glow.module.css'

export const ColorGlow = ({ children }) => {
    return (
        <div className={CSS.container}>
            <span className={CSS.color}/>
            <span className={CSS.color}/>
            <span className={CSS.color}/>
            <span className={CSS.color}/>

            { children }
        </div>
    )
}